import { render, staticRenderFns } from "./sfc-header.vue?vue&type=template&id=d9f54890&scoped=true&lang=pug&"
import script from "./sfc-header.vue?vue&type=script&lang=js&"
export * from "./sfc-header.vue?vue&type=script&lang=js&"
import style0 from "./sfc-header.vue?vue&type=style&index=0&id=d9f54890&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f54890",
  null
  
)

export default component.exports